// ../../services/redux/thunks/stepperDynamicFormThunks.ts

import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  setDisplayHorizontalSteps,
  setFormJson, // Keeping setFormJson as it likely sets the root object containing horizontalSteps
  setLoading,
  setIsFetchingFormJson,
  setProducts,
} from "../slices/stepperDynamicFormSlice";
import { getCombinedApplicationSteps } from "../../../components/ui/StepperDyanmicForm/helper";
import eligibilityCheckServices from "../../api/service/eligibilityCheckService";
// import mockFormJson from "../../../data/dynamic-form.json"; // Assuming this is no longer used
import type { RootState } from "../store";

// ======================================================
// 1. ASYNC THUNK: Fetch Form JSON Data (API CALL)
// ======================================================
export const getFormJson = createAsyncThunk(
  "stepper/getFormJson",
  async (
    {
      product,
      loaderShow = true,
      callBack,
      trackingId,
    }: {
      product?: string;
      loaderShow?: boolean;
      callBack?: (type: string) => void;
      trackingId?: string;
    },
    { dispatch, getState }
  ) => {
    const state = getState() as RootState;
    const { selectedProduct, isFetchingFormJson } = state.stepper;

    // Guard against duplicate in-flight requests (e.g., React StrictMode double effects)
    if (isFetchingFormJson) {
      return;
    }
    dispatch(setIsFetchingFormJson(true));
    const authProfile = state?.auth?.userProfile;

    if (loaderShow) {
      dispatch(setLoading(true));
    }
    try {
      const payload = {
        productCode: product || selectedProduct || "SLI",
        id: authProfile?.id,
        trackingId: trackingId,
      };

      const res = await eligibilityCheckServices.getForm(payload);
      if (res.status === 200) {
        const response: any = res.data.data;

        // **Removed the original stepper calculation logic here.**

        // Sort each vertical step's fields by fieldOrder (can be int or float)
        response.horizontalSteps?.forEach((hStep: any) => {
          hStep?.verticalSteps?.forEach((vStep: any) => {
            if (Array.isArray(vStep?.fields)) {
              vStep.fields.sort(
                (a: any, b: any) => Number(a?.fieldOrder) - Number(b?.fieldOrder)
              );
            }
          });
        });

        const formJson: any = response.horizontalSteps.filter(
          (elem: any) => elem?.stepKey == "eligibility_check"
        );
        formJson?.[0]?.verticalSteps.push({
          id: 4,
          stepLabel: "Confirmation on Eligibility",
          stepOrder: 4,
          fields: [],
        });

        // 1. Set the main form data in the store
        dispatch(setFormJson(response));

        // 2. Immediately trigger the recalculation based on the newly available data.
        // This ensures steps are displayed right after the API succeeds, even on initial load.
       // dispatch(recalculateHorizontalSteps());

        if (loaderShow) {
          dispatch(setLoading(false));
        }
        if (callBack) {
          callBack("form");
        }
        return res.data;
      } else {
        throw new Error("Failed to fetch form JSON");
      }
    } catch (error: any) {
      console.error("Error fetching form JSON:", error);
      dispatch(setLoading(false)); // Ensure loader is hidden on failure
      // ... (Rest of error handling, e.g., using mock data)
    } finally {
      dispatch(setIsFetchingFormJson(false));
    }
  }
);

// ======================================================
// 2. THUNK: Recalculate Horizontal Step Status (LOCAL STATE)
// ======================================================
/**
 * Calculates and dispatches the status of the horizontal steps based on
 * the current activeHorizontalIndex and the loaded horizontalSteps data.
 * This function should be called after 'getFormJson' AND when 'activeHorizontalIndex' changes.
 */
export const recalculateHorizontalSteps =
  () => (dispatch: any, getState: () => RootState) => {
    const state = getState();
    const { horizontalSteps } = state.stepper;
    const applicationStatus = state.tabs?.applicationStatus;

    // IMPORTANT: Check if the required data is available in the store
    if (!horizontalSteps || horizontalSteps.length === 0) {
      // Data not loaded yet, exit gracefully.
      return;
    }

    // Use  to properly handle all statuses including "Disbursed"
    const appData = {
      horizontalSteps: horizontalSteps,
      submissionId: state.stepper.trackingId || "",
      createdAt: "",
      updatedAt: "",
      isProvisionalGenerated: state.stepper.breData?.isProvisionalGenerated,
      isQualified: state.stepper.breData?.isQualified,
      isEligibilityChecked: state.stepper.breData?.isEligibilityChecked,
      partnerStartedJourney: state.stepperDynamicForm?.partnerStartedJourney,
    };
    console.log(state.stepper,"stepperstatestepperstate")
    const finalSteps = getCombinedApplicationSteps(appData, applicationStatus);

    // Dispatch the calculated steps to update the display
    dispatch(setDisplayHorizontalSteps(finalSteps));
    
    
  };

// ======================================================
// 3. THUNK: Fetch Products (API CALL)
// ======================================================
export const fetchProducts = () => async (dispatch: any) => {
  try {
    const res = await eligibilityCheckServices.getProducts();
    if (res.data && Array.isArray(res.data.data)) {
      dispatch(setProducts(res.data.data));
    }
  } catch (error) {
    // Optionally handle error
    dispatch(setProducts([]));
  }
};
